// Demo hostnames get demo-only UI restrictions (pre-filled/locked login,
// disabled Delete Account / Change Password). Testdev and Live are unaffected.
const DEMO_HOSTNAMES = ["mapmypay-demo.testdevurl.com"];

export const isDemoSite = () => DEMO_HOSTNAMES.includes(window.location.hostname);

export const DEMO_CREDENTIALS = {
  email: "demo@mapmypay.com",
  password: "Demo@2026",
};
